import React from 'react'
import ButtonLoading from './ButtonLoading'

const AddTransportModal = ({ closeModal, addonName, setAddonName, addonPrice, setAddonPrice, submitHandler, loading, error, success }) => {
  return (
    <div>
      <div
        className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-md"
        onClick={closeModal}>
      </div>

      <div
        id="authentication-modal"
        tabIndex="-1"
        aria-hidden="true"
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
      >
        <div className="w-full max-w-md">
          <div className="rounded-2xl bg-white shadow-xl dark:bg-gray-700">
            <div className="flex items-center justify-between border-b border-slate-200 px-5 py-4 dark:border-gray-600">
              <div>
                <h3 className="text-lg font-semibold text-slate-900 dark:text-white">
                  Add Bus Location
              </h3>
                <p className="text-xs text-slate-500 dark:text-slate-300">
                  Create a new transport location and price.
                </p>
              </div>
              <button
                type="button"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full text-slate-500 hover:bg-slate-100 hover:text-slate-700 dark:hover:bg-gray-600 dark:hover:text-white"
                data-modal-hide="authentication-modal"
                onClick={closeModal}
              >
                <svg className="h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <div className="px-5 py-4">
              {error && (
                <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
                    {error}
                </div>
              )}
              {success && (
                <div className="mb-4 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
                  New location added successfully.
                </div>
              )}
              <form onSubmit={submitHandler} className="space-y-4">
                <div>
                  <label htmlFor="transport-location" className="block text-sm font-medium text-slate-700 dark:text-slate-200">
                    Bus Location
                  </label>
                  <input
                    id="transport-location"
                    type="text"
                    onChange={(e) => setAddonName(e.target.value)}
                    value={addonName}
                    placeholder="e.g. Downtown Route"
                    className="mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 dark:border-gray-600 dark:bg-gray-800 dark:text-white"
                  />
                </div>
                <div>
                  <label htmlFor="transport-price" className="block text-sm font-medium text-slate-700 dark:text-slate-200">
                    Price
                  </label>
                  <input
                    id="transport-price"
                    type="number"
                    onChange={(e) => setAddonPrice(e.target.value)}
                    value={addonPrice}
                    placeholder="e.g. 20000"
                    className="mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 dark:border-gray-600 dark:bg-gray-800 dark:text-white"
                  />
                </div>
                <div className="pt-2">
                  {loading ? (
                    <ButtonLoading styles="w-full text-white bg-blue-600 focus:outline-none font-medium rounded-full text-sm px-5 py-2.5 text-center" />
                  ) : (
                    <button type="submit" className="w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center">
                      Save Record
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div> 
    </div>
  )
}

export default AddTransportModal